import isABTest from '../ab/isabtest';
import useABTestContext from '../hooks/useABTestContext';
import ABTestsReducerInitialState from '../reducers/ABTestsReducer/ABTestsReducerInitialState';
import { type IABTest } from '../types/abContextType';

export const getABTests = (): IABTest[] => {
  const abTests = ABTestsReducerInitialState;
  const allTests: IABTest[] = [];

  abTests.forEach((test: string) => {
    allTests.push({ name: test, variant: isABTest(test) });
  });

  return allTests;
};

/** Checks if a given test name is active or not. */
export function isTestActive (testName: string): boolean {
  const { abTests } = useABTestContext();
  return (abTests.some(test => test.name === testName && test.variant));
}
